export default {

    init() {
        console.log('init common...');
        document.addEventListener("DOMContentLoaded", this.bindEvents);
    },

    bindEvents() {
        const header = document.querySelector('.sh-site-header');
        const toggle = document.querySelector('.menu-toggle');
        const menu = document.querySelector('.header-menu nav');
        const subnavElements = menu.querySelectorAll('li.has-children');

        Common.header = header;
        Common.navToggle = toggle;
        Common.navMenu = menu;
        Common.subnavElements = subnavElements;

        // Mobile menu toggle
        toggle.addEventListener('click', Common.toggleNav);

        // Mobile subnav and desktop dropdowns
        subnavElements.forEach(elem => {
            var subnavToggle = elem.querySelector(':scope > a');
            subnavToggle.addEventListener('click', Common.toggleSubnav);
        });

        // Scroll watcher
        Common.navScrollWatcher();
        Common.homeScrollWatcher();
    },

    toggleNav(e) {
        if (Common.navMenu.classList.contains('is-open')) {
            Common.closeNav();
        } else {
            Common.openNav();
        }
    },

    openNav() {
        document.querySelector('html').classList.add('is-nav-open');
        Common.navMenu.classList.add('is-open');
        Common.navToggle.setAttribute('aria-expanded', 'true');

        // Listen for resize and close menus
        window.addEventListener('resize', Common.navState, false);
    },

    closeNav() {
        document.querySelector('html').classList.remove('is-nav-open');
        Common.navMenu.classList.remove('is-open');
        Common.navToggle.setAttribute('aria-expanded', 'false');
        Common.closeAllSubnavs();

        // Stop listening for resize
        window.removeEventListener('resize', Common.navState, false);
    },

    toggleSubnav(e) {
        e.preventDefault();
        var toggle = e.currentTarget;
        var parent = toggle.parentElement;
        var submenu = (parent) ? parent.querySelector(':scope > .submenu') : null; 

        if (!toggle || !submenu) {
            return;
        }

        if (submenu.classList.contains('is-open')) {
            Common.closeSubnav(toggle, submenu);
        } else {
            Common.openSubnav(toggle, submenu);
        }
    },

    openSubnav(toggle, submenu) {
        if (!toggle || !submenu) {
            return;
        }

        Common.closeAllSubnavs();

        
        toggle.setAttribute('aria-expanded', 'true');
        submenu.classList.add('is-open');

        if (!Common.isMobile()) {
            Common.header.classList.add('is-header-fixed');
        }

        document.addEventListener('click', Common.navClickOutside);
    },

    closeSubnav(toggle, submenu) {
        if (!toggle || !submenu) {
            return;
        }

        toggle.setAttribute('aria-expanded', 'false');
        submenu.classList.remove('is-open');
    },

    closeAllSubnavs() {
        Common.subnavElements.forEach(elem => {
            var toggle = elem.querySelector(':scope > a');
            var submenu = elem.querySelector(':scope > .submenu');

            Common.closeSubnav(toggle, submenu);
        });

        Common.navFixedState();

        document.removeEventListener('click', Common.navClickOutside);
    },

    navClickOutside(e) {
        if (!Common.navMenu.contains(e.target)) {
            Common.closeAllSubnavs();
        }
    },

    navState() {
        Common.closeNav();
        Common.closeAllSubnavs();
    },

    navFixedState() {
        let threshold = Common.header.offsetHeight / 2;

        if (window.scrollY > Common.scrollPreviousY) {
            Common.scrollDirection = 'down'
        } else {
            Common.scrollDirection = 'up'
        }

        Common.scrollPreviousY = window.scrollY;
        
        if (Common.scrollPreviousY > threshold) {
            Common.header.classList.add('is-header-fixed', 'page-has-scrolled');
        } else {
            Common.header.classList.remove('is-header-fixed');
        }

        if (Common.scrollDirection === 'down' && Common.scrollPreviousY > threshold) {
            Common.closeAllSubnavs();
            Common.header.classList.add('is-header-fixed-hidden');
        } else {
            Common.header.classList.remove('is-header-fixed-hidden');
        }
    },

    navScrollWatcher() {
        let prevY = 0;
        let direction = 'up';
        
        Common.scrollDirection = direction;
        Common.scrollPreviousY = prevY;

        Common.navFixedState();
        window.addEventListener('scroll', Common.navFixedState);
    },

    homeScrollState() {
        const intro = document.querySelector('.home-intro');
        let top = intro.getBoundingClientRect().top;

        if (top <= 0) {
            intro.classList.add('is-fixed');
        } else {
            intro.classList.remove('is-fixed');
        }
    },

    homeScrollWatcher() {
        const isHome = document.body.classList.contains('home');
        const intro = document.querySelector('.home-intro');

        if (!isHome && !intro) {
            return;
        }

        Common.homeScrollState();
        window.addEventListener('scroll', Common.homeScrollState);
    },

    isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches;
      }

}